(() => {
  const source = document.currentScript;
  const productId = source?.dataset.productId;
  if (!productId || !/^\d+$/.test(productId)) return;
  const enrich = () => {
    const entries = [];
    for (const script of document.querySelectorAll('script[type="application/ld+json"]')) {
      try {
        const data = JSON.parse(script.textContent);
        if (data['@type'] === 'Product') entries.push({ script, data });
      } catch {}
    }
    const target = entries.find(({ data }) => data.offers && data['@id'] === source.dataset.productSchemaId);
    if (!target || entries.some(({ data }) => data['@id'] === target.data['@id'] && data.review)) return;
    let widget;
    const pattern = new RegExp('reviewWidget\\[' + productId + '\\]\\s*=\\s*(\\{[\\s\\S]*\\})\\s*;?\\s*$');
    for (const script of document.querySelectorAll('script.jdgm-review-widget-data')) {
      const match = script.textContent.match(pattern);
      if (match) {
        try { widget = JSON.parse(match[1]); } catch {}
      }
    }
    if (!widget || String(widget.product_external_id) !== productId) return;
    const count = Number(widget.number_of_reviews);
    const average = Number(widget.average_rating);
    if (!Number.isInteger(count) || count < 1 || !(average >= 1 && average <= 5)) return;
    const reviews = (widget.reviews || []).filter(review =>
      !review.is_for_product_from_group && !review.is_for_product_from_bundle &&
      typeof review.reviewer_name === 'string' && review.reviewer_name.trim() &&
      typeof review.body === 'string' && review.body.trim() &&
      Number(review.rating) >= 1 && Number(review.rating) <= 5
    ).map(review => {
      const result = {
        '@type': 'Review',
        author: { '@type': 'Person', name: review.reviewer_name },
        reviewRating: { '@type': 'Rating', ratingValue: Number(review.rating), bestRating: 5, worstRating: 1 },
        reviewBody: review.body
      };
      if (review.created_at && !Number.isNaN(Date.parse(review.created_at))) {
        result.datePublished = new Date(review.created_at).toISOString().slice(0, 10);
      }
      return result;
    });
    if (!reviews.length) return;
    if (!entries.some(({ data }) => data['@id'] === target.data['@id'] && data.aggregateRating)) {
      target.data.aggregateRating = { '@type': 'AggregateRating', ratingValue: average, reviewCount: count, bestRating: 5, worstRating: 1 };
    }
    target.data.review = reviews;
    target.script.textContent = JSON.stringify(target.data).replace(/</g, '\\u003c');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enrich, { once: true });
  else enrich();
})();
